import { SparkleContext } from "../context";
import React from "react";
export const LinkWrapper = React.forwardRef(({ children, href, rel, replace, shallow, target, prefetch, className, tabIndex, }, ref) => {
    const { components } = React.useContext(SparkleContext);
    if (href) {
        return (React.createElement(components.link, { ref: ref, href: href, target: target, rel: rel, replace: replace, shallow: shallow, prefetch: prefetch, className: className, tabIndex: tabIndex }, children));
    }
    return children;
});
//# sourceMappingURL=LinkWrapper.js.map